<script setup>
import Delimiter from '@sections/delimiter.vue'
import AboutSection from '@sections/home-page/about.vue'
import BlogSection from '@sections/home-page/blog.vue'
import ContactSection from '@sections/home-page/contact.vue'
import HeroSection from '@sections/home-page/hero.vue'
import MerchSection from '@sections/home-page/merch.vue'
import ProductsSection from '@sections/home-page/products.vue'
import VideoSection from '@sections/home-page/video.vue'
</script>

<template>
	<HeroSection />
	<!-- <MerchSection title="Merch" /> -->
	<!-- <ProductsSection /> -->
	<AboutSection />
	<VideoSection />
	<BlogSection />
	<ContactSection />
	<Delimiter />
</template>
